// modules/land-for-sale/elements/PlanLotsContainer.js
import React        from 'react';
import PlanLotOutline  from './PlanLotOutline';
import PlanSoldOutline  from './PlanSoldOutline';

class PlanLotsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.renderLotHovers = this.renderLotHovers.bind(this);
    }

    renderLotHovers(element) {
        if(element.status === 1) {
            return (
                <div key={element.id} className="c">
                    <PlanLotOutline  width={this.props.width} height={this.props.height}
                                    element={element} messenger={this.props.messenger} dclass={'landforsale-lot'}/>
                </div>
        )
        } else if (element.status === 3) {
	        return (
		        <div key={element.id} className="c">
			        <PlanLotOutline  width={this.props.width} height={this.props.height}
			                          element={element} messenger={this.props.messenger} dclass={'landforsale-hold'}/>
		        </div>
	        )
        } else {
            return (
                <div key={element.id} className="landforsale-sold">
                    <PlanSoldOutline  width={this.props.width} height={this.props.height}
                                     element={element} messenger={this.props.messenger}/>
                </div>
            )
        }
    }

    render() {
        return(
            <div className="landforsale-map_lots_container">
                {this.props.elements.map(this.renderLotHovers)}
            </div>
        )
    }
}
export default PlanLotsContainer;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanLotsContainer.js
 **/